<script setup lang="ts">
let props = defineProps({
  isDown: {
    type: Boolean,
    default: true
  }
});
</script>

<template>
  <svg v-if="props.isDown" width="24" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.6239 7.40894L12.7148 13.318L6.80569 7.40894L5.21484 8.99992L12.7148 16.4999L20.2148 8.99992L18.6239 7.40894Z"
          class="tw-fill-[#212529] dark:tw-fill-white"/>
  </svg>
  <svg v-else width="24" height="24" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" viewBox="0 0 6.3499999 6.3500002"
       version="1.1" id="fi_8287014">
    <defs id="defs2">
      <marker style="overflow:visible" id="marker7745" refX="0.0" refY="0.0" orient="auto">
        <path transform="scale(-0.4)" style="fill-rule:evenodd;fill:context-stroke;stroke:context-stroke;stroke-width:1.0pt"
              d="M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z " id="path7743"></path>
      </marker>
      <marker style="overflow:visible" id="marker7503" refX="0.0" refY="0.0" orient="auto">
        <path transform="scale(-0.2)" style="fill-rule:evenodd;fill:context-stroke;stroke:context-stroke;stroke-width:1.0pt"
              d="M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z " id="path7501"></path>
      </marker>
      <marker style="overflow:visible" id="Arrow1Sstart" refX="0.0" refY="0.0" orient="auto">
        <path transform="scale(0.2) translate(6,0)" style="fill-rule:evenodd;fill:context-stroke;stroke:context-stroke;stroke-width:1.0pt"
              d="M 0.0,0.0 L 5.0,-5.0 L -12.5,0.0 L 5.0,5.0 L 0.0,0.0 z " id="path7181"></path>
      </marker>
      <marker style="overflow:visible" id="TriangleInS" refX="0.0" refY="0.0" orient="auto">
        <path transform="scale(-0.2)" style="fill-rule:evenodd;fill:context-stroke;stroke:context-stroke;stroke-width:1.0pt"
              d="M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z " id="path7308"></path>
      </marker>
      <marker style="overflow:visible" id="TriangleInM" refX="0.0" refY="0.0" orient="auto">
        <path transform="scale(-0.4)" style="fill-rule:evenodd;fill:context-stroke;stroke:context-stroke;stroke-width:1.0pt"
              d="M 5.77,0.0 L -2.88,5.0 L -2.88,-5.0 L 5.77,0.0 z " id="path7305"></path>
      </marker>
    </defs>
    <g id="layer1">
      <path class="tw-fill-black dark:tw-fill-white" style="color:rgb(0,0,0);stroke-linecap:round;stroke-linejoin:round;-inkscape-stroke:none"
            d="M 5.2912383,3.9865476 A 0.2645835,0.2645835 0 0 0 5.2267851,3.7951414 L 3.3732695,1.6779539 a 0.26460996,0.26460996 0 0 0 -0.3984375,0 L 1.1232695,3.7951414 A 0.2645835,0.2645835 0 0 0 1.1486601,4.1681882 0.2645835,0.2645835 0 0 0 1.521707,4.1427976 L 3.1740507,2.2541258 4.8283476,4.1427976 a 0.2645835,0.2645835 0 0 0 0.3730469,0.025391 0.2645835,0.2645835 0 0 0 0.089844,-0.181641 z"
            id="path911"></path>
    </g>
  </svg>
</template>

<style scoped>

</style>